module.exports = __webpack_public_path__ + "static/media/Montserrat-Thin.43dd5b7a.ttf";